import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	improveSearch: {
		id: 'search-page.app-filter-sidebar.improve-search',
		defaultMessage: 'Improve search',
		description: 'Label that links to a CTA to give feedback',
	},
});
